import React from 'react';
import Chip from '@material-ui/core/Chip';
import getColorFromMUI from 'src/utils/getColorFromMUI';
import { useTheme } from '@material-ui/core/styles';

const CustomChip = ({ label = '', color = 'default', style = {}, ...rest }) => {
  const theme = useTheme();
  const bgColor = getColorFromMUI({ color });
  const textColor = theme.palette.getContrastText(bgColor);
  return (
    <Chip
      label={label}
      size="small"
      color="primary"
      style={{
        ...style,
        backgroundColor: bgColor,
        color: textColor
      }}
      {...rest}
    />
  );
};

export default CustomChip;
